/**
 * Module-singleton ``WSClient`` instance.
 *
 * One socket per browser tab — the ``_authed`` route mounts a provider that
 * calls ``connect()`` on it and ``disconnect()`` on unmount. Putting the
 * instance in module scope (vs context) makes it cheap to import from any
 * non-React code-path (queryFn, optimistic mutation, dev console).
 *
 * The instance is created lazily so server-side imports in the Next.js
 * BFF route handlers don't reach for ``window`` at module-eval time.
 */

import { WSClient } from "@ando/core/ws";

let instance: WSClient | null = null;

export function getWsClient(): WSClient {
  if (!instance) instance = new WSClient();
  return instance;
}
